import React, { useState, useEffect } from 'react';
import './styles/Novedades.css';
import banner1 from '../archivos/banners/banner1.jpg';
import { Box, Grid, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { RoundedDialog } from './styles/RoundedDialog';
import { withTranslation } from 'react-i18next';
import { newsActions } from '../service';

const Novedades = (props) => {
	const { t, i18n } = props;
	const es = i18n.language === 'es';
	const [modal, setModal] = useState(false);
	const [novedades, setNovedades] = useState();
	const [novedad, setNovedad] = useState();

	// La lista de novedades deberia empezar por la ultima novedad cargada

	useEffect(() => {
		newsActions.get().then(res => {
			const reversed = res.reverse()
			setNovedades(reversed)
		})
	}, []);
	
	const handleClick = (novedad) => {
		setNovedad(novedad);
		setModal(true);
	};

	return (
		<Box id="news" sx={{ backgroundColor: '#e83484', color: 'white', padding: '80px' }}>
			<h3 className='titleN'>{t('Novedades.titulo')}</h3>
			<Grid container spacing={6} className="newsContainer">
				{novedades?.map((n) => {
					return (
						<Grid item xs={12} md={6} lg={4} xl={4} key={n._id}>
							<img
									src={n.imgUrl ? n.imgUrl : banner1}
								width='100%'
								height='350px'
								alt='Imagen de computadora con código'
								className='imageN'
							/>
							<h4 className='cardTitleN'>{es ? n.title.es : n.title.en}</h4>
							<p>
								{es ? `${n.abstract.es.slice(0, 180)} . . .` : `${n.abstract.en.slice(0, 180)} . . .`}
							</p>
							<div className='cardButtonBoxN'>
								<button className='cardButtonN' onClick={() => handleClick(n)}>
									{t('Novedades.boton')}
								</button>
							</div>
						</Grid>
					);
				})}
			</Grid>
			{modal && (
				<RoundedDialog
					open={true}
					fullWidth
					maxWidth='md'
					style={{ border: '1px solid black', borderRadius: '25px' }}
				>
					<IconButton
						onClick={() => setModal(false)}
						sx={{
							position: 'absolute',
							right: '10px',
							top: '10px',
							backgroundColor: 'black',
							color: 'white',
						}}
					>
						<Close />
					</IconButton>
					<img
						src={novedad.imgUrl ? novedad.imgUrl : banner1}
						width='100%'
						height='150px'
						alt='Imagen de computadora con código'
						className='imageDialogN'
					/>
					<Box sx={{ padding: '20px 80px', backgroundColor: '#00EECE' }}>
						<h4 className='dialogTitleN'>{es ? novedad.title.es : novedad.title.en}</h4>
						<p className='dialogP'>{es ? novedad.description.es : novedad.description.en}</p>
					</Box>
				</RoundedDialog>
			)}
		</Box>
	);
};

export default withTranslation()(Novedades);
